import type { ValidateResult } from 'react-form';
import type { CountryCode } from 'libphonenumber-js';

export const validPhoneNumber = async (phone: string, country: string): Promise<ValidateResult> => {
  const { isValidPhoneNumber } = await import(/* webpackChunkName: "libphonenumber-js" */ 'libphonenumber-js/min');

  try {
    if (!isValidPhoneNumber(phone, country.toUpperCase() as CountryCode)) {
      return 'Please provide a valid phone number.';
    }
    return false;
  } catch (error) {
    return 'Please provide a valid phone number.';
  }
};
